function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 3 Copy 3");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admin-UI",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "033-admin-users-detail",
  transform: "translate(-320.000000, -115.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-3",
  transform: "translate(320.000000, 115.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  fill: "#F2F2F2",
  cx: 28.5,
  cy: 28.5,
  r: 28.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5,27.625 C22.465,27.625 21.625,28.465 21.625,29.5 C21.625,30.535 22.465,31.375 23.5,31.375 C24.535,31.375 25.375,30.535 25.375,29.5 C25.375,28.465 24.535,27.625 23.5,27.625 Z M32.5,27.625 C31.465,27.625 30.625,28.465 30.625,29.5 C30.625,30.535 31.465,31.375 32.5,31.375 C33.535,31.375 34.375,30.535 34.375,29.5 C34.375,28.465 33.535,27.625 32.5,27.625 Z M28,13 C19.72,13 13,19.72 13,28 C13,36.28 19.72,43 28,43 C36.28,43 43,36.28 43,28 C43,19.72 36.28,13 28,13 Z M28,40 C21.385,40 16,34.615 16,28 C16,27.565 16.03,27.13 16.075,26.71 C19.615,25.135 22.42,22.24 23.89,18.655 C26.605,22.495 31.075,25 36.13,25 C37.3,25 38.425,24.865 39.505,24.61 C39.82,25.675 40,26.815 40,28 C40,34.615 34.615,40 28,40 Z",
  id: "Shape",
  fill: "#FF5900"
}))));

const SvgUserIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "57px",
    viewBox: "0 0 57 57",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user_icon.b34ea91f.svg";
export { ForwardRef as ReactComponent };